enum SaleType {
  IDO = 'ido',
  INO = 'ino'
}

export default SaleType
